import request from '@/utils/request'
// 获取俱乐部基本信息
export function getContactBase (query) {
  return request({
    url: '/contact/us/get',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/contactUs.js